import React from 'react';
import axios from "../../../../containers/api";
import {Button, Card, CardBody, Row, Label, Input, FormGroup} from "reactstrap";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import {getCheckMemberTypeIsAdmin, showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";

class Contact extends React.Component {
    state = {
        ContactId :"",
        Name: "",
        SupportTell: "",
        Tell: "",
        Mobile: "",
        Fax: "",
        Email: "",
        Site: "",
        Address: "",
        Rules: ""
    };

    componentDidMount() {
        try {
            this.CheckMemberTypeIsAdmin().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }

    async CheckMemberTypeIsAdmin() {
        try {
            await getCheckMemberTypeIsAdmin(this.props.showSpinner, this.props.hideSpinner).then((res) => {
                if (res) {
                    this.getContactSettings();
                } else {
                    this.props.history.push('/error401');
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    getContactSettings = () => {
        this.props.showSpinner();
        axios.get('api/ContactApi/GetContact')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({
                    ContactId: res.data.contactId,
                    Name: res.data.name,
                    SupportTell: res.data.suportTell,
                    Tell: res.data.tell,
                    Mobile: res.data.mobile,
                    Fax: res.data.fax,
                    Email: res.data.email,
                    Site: res.data.site,
                    Address: res.data.address,
                    Rules: res.data.rules
                });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error")
                console.log(error.response);
            });
    };

    submitUpdate = () => {
        const ContactModel = {
            ContactId: toEnglishNumbers(this.state.ContactId),
            Name: toEnglishNumbers(this.state.Name),
            SupportTell: toEnglishNumbers(this.state.SupportTell),
            Tell: toEnglishNumbers(this.state.Tell),
            Mobile: toEnglishNumbers(this.state.Mobile),
            Fax: toEnglishNumbers(this.state.Fax),
            Email: toEnglishNumbers(this.state.Email),
            Site: toEnglishNumbers(this.state.Site),
            Address: toEnglishNumbers(this.state.Address),
            Rules: toEnglishNumbers(this.state.Rules)
        };

        if (ContactModel.Name === null || ContactModel.Name === "") {
            this.props.showAlert("لطفا نام را وارد کنید", "error");
        } else {
            this.props.showSpinner();
            axios.post('api/ContactApi/Updatecontact', ContactModel)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert("اطلاعات با موفقیت بروز رسانی شد", "success");
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    this.props.showAlert(showCatchError(error), "error")
                    console.log(error.response);
                });
        }
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>تنظیمات اطلاعات تماس</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-md-row flex-column flex-wrap justify-content-center align-items-center">
                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>نام</Label>
                                    <Input value={this.state.Name}
                                           onChange={(e) => this.setState({Name: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>تلفن پشتیبانی</Label>
                                    <Input value={this.state.SupportTell}
                                           onChange={(e) => this.setState({SupportTell: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>تلفن</Label>
                                    <Input value={this.state.Tell}
                                           onChange={(e) => this.setState({Tell: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>موبایل</Label>
                                    <Input value={this.state.Mobile}
                                           onChange={(e) => this.setState({Mobile: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>فکس</Label>
                                    <Input value={this.state.Fax}
                                           onChange={(e) => this.setState({Fax: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>ایمیل</Label>
                                    <Input value={this.state.Email}
                                           onChange={(e) => this.setState({Email: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-50 w-100 mx-1">
                                    <Label>آدرس</Label>
                                    <Input value={this.state.Address} type="textarea"
                                           onChange={(e) => this.setState({Address: e.target.value})}/>
                                </FormGroup>

                                <FormGroup className="w-md-50 w-100 mx-1">
                                    <Label>قوانین و مقررات</Label>
                                    <Input value={this.state.Rules} type="textarea"
                                           onChange={(e) => this.setState({Rules: e.target.value})}/>
                                </FormGroup>

                                <div className="d-flex w-100 justify-content-center mt-4">
                                    <Button color="primary" className="btn-lg mx-2" onClick={this.submitUpdate}>
                                        ثبت
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
            </>
        )
    }
}

export default Contact;